import React from 'react';
import {Label} from "../../../common/fusion-ui";
import {useTheme} from "../../../common/ProjectThemeProvider";

const AdminFooter = React.memo(({position = 'fixed'}) => {
    const theme = useTheme();


    return (<>
        <div className={`w-100 m-0 p-0 py-0 px-2 py-1 position-${position}`}
             style={{left: '0rem', bottom: '0rem', backgroundColor: theme.primary10}}>
            <div className={'w-100 d-flex jc-center al-center al-start-sm fd-row flex-wrap'}>
                <Label className={'m-0 p-0 px-1 mx-2 text-wrap text-theme-resp'} textAt={'start'}>
                    <span className={'text-wrap px-1'}>{`© Copyright ${new Date().getFullYear()}`} </span>
                    <span className={'text-wrap px-1'}>{` KOLs and Peers. All Rights Reserved.`}</span>
                </Label>

                <Label className={'m-0 p-0 px-1 mx-2 text-wrap text-theme-resp'} textAt={'start'}>
                    {`Made by KOLs and Peers Analytics.`}
                </Label>
            </div>
        </div>
    </>);
});

export default AdminFooter;
